module.exports = __webpack_public_path__ + "static/media/job-dropdown.915384b2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/job-dropdown.svg
// module id = 1303
// module chunks = 1